/**************************************************
 * Nombre:       Formulario_Detalle_Campana
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {ApartmentOutlined, CampaignOutlined, Flag, MoneyOutlined, WhatsApp} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {PAISESINDICATIVO} from "../../Modulo_formularios/Recursos/indicativos";
import Tarjeta_Funnel_Pq from "../Tarjetas/Tarjeta_Funnel_Pq";
import IngresoTextoArray from "../../Modulo_formularios/Componentes/IngresoTextoArray";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import {useContext, useState} from "react";
import {enviarPeticion} from "../../Modulo_Peticiones/Peticiones/enviarPeticion";
import {getValue} from "@mui/system";
import {usuarioContext} from "../../App";

const Formulario_Detalle_Campana = ({...props}) => {
    const cData = useContext(usuarioContext);
    const [cargando, setCargando] = useState(false);

    const dias = () => {
        let arr = []
        for (let i = 1; i < 31; i++) {
            arr.push(i)
        }

        return arr
    }


    const verificarNumero = async () =>{
        setCargando(true);

        let datos = props.props.getValues()
        datos.nombreUsuario = cData.usuario.nombres
        await enviarPeticion({datos: datos, flujo: 'prueba'})
        setCargando(false);

    }

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >



                <Grid container size={6}>
                    <IngresoDinero Icono={MoneyOutlined} nombre={'Inversion'}
                                   dato={'valor'} {...props}
                                   opciones={PAISESINDICATIVO.map((it) => it.nameES)}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={CampaignOutlined} nombre={'Dias de Anuncios'}
                                   dato={'numDias'} {...props}
                                   opciones={dias()}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontWeight: 600}}>Zona de Anuncios</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoSelect Icono={Flag} nombre={'Pais de Enfoque'} dato={'pais'} {...props}
                                   opciones={PAISESINDICATIVO.map((it) => it.nameES)}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTextoArray Icono={ApartmentOutlined} nombre={'Ciudades'} dato={'ciudades'} {...props}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontWeight: 600}}>Celular de Notificacion Nuevo Lead</Typography>
                </Grid>

                <Grid container size={8}>
                    <IngresoTexto Icono={WhatsApp} nombre={'Numero WhatsApp (con indicativo)'}
                                  dato={'celular'} {...props}
                                  opciones={PAISESINDICATIVO.map((it) => it.nameES)}
                    />
                </Grid>

                <Grid container size={4} sx={{justifyContent: 'flex-end'}}>
                    <Button
                        loading={cargando}
                        onClick={() => verificarNumero()}
                        variant={'outlined'} >Verificar</Button>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Detalle_Campana